import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserServiceOfferRepository } from './domain'

import {
  UserServiceOfferDetails,
  UserServiceOfferLogDetails,
  UserServiceOfferOptions,
  UserServiceOfferUserLog,
} from '../../contracts/service-offer'
import { AxiosErrorHandler } from '../../foundation'

export class UserApiServiceOffer implements UserServiceOfferRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getById = async (id: number): Promise<UserServiceOfferDetails> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/service-offer/query/user/service-offer-detail/process',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<UserServiceOfferDetails>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getOptions = async (serviceOfferId: number): Promise<UserServiceOfferOptions> => {
    const config: AxiosRequestConfig<{ serviceOfferId: number }> = {
      url: '/service-offer/query/user/options/process',
      method: 'post',
      data: { serviceOfferId },
    }

    try {
      const { data } = await this.axios.request<UserServiceOfferOptions>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getLogDetails = async (id: number): Promise<UserServiceOfferLogDetails> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/service-offer/log/query/service-offer-detail/process',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<UserServiceOfferLogDetails>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  trackViewed = async (id: number): Promise<void> => {
    const config: AxiosRequestConfig<{ id: number }> = {
      url: '/command/user/service-offer-detail-viewed/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<UserServiceOfferLogDetails>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  postUserLog = async (log: UserServiceOfferUserLog): Promise<void> => {
    const config: AxiosRequestConfig<UserServiceOfferUserLog> = {
      url: '/v1/user-log/event',
      method: 'post',
      data: log,
    }

    try {
      await this.axios.request<UserServiceOfferUserLog>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
